import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import {
  BetmenList,
  BetmenListHeader,
  BetmenListHeaderCell,
  BetmenListBody,
  BetmenListItemCard,
  BetmenListItemCardCell,
} from '../../../../../common/components'
import VaccinesIcon from '@mui/icons-material/Vaccines'
import { UsePatientEProfileReturn } from '../../hooks/usePatientEProfile'
import { PatientDetailsSectionHeader } from './PatientDetailsSectionHeader'
import { PatientDetailsActions } from './PatientDetailsActions'

export const PatientVaccinations: React.FC<UsePatientEProfileReturn> = ({
  patientDetails,
  isLoading,
  isEditable,
}) => {
  const { t } = useTranslation()

  const hasData = patientDetails.vaccinations.length > 0

  return (
    <Box bgcolor={'primary.100'} py={2} borderRadius={3}>
      <PatientDetailsSectionHeader
        icon={<VaccinesIcon fontSize="large" />}
        title={t('doctor:patientProfile.vaccinations.title')}
        hasData={hasData}
      />

      {(isLoading || hasData) && (
        <BetmenList
          dataSource={patientDetails.warnings}
          loading={isLoading}
          gridColumnSizes={[1, 8, 2, 1]}
          extraHeaderStyle={{ backgroundColor: 'transparent' }}
          stickyHeader={false}
          header={
            <BetmenListHeader>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.vaccinations.header.code')}
              </BetmenListHeaderCell>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.vaccinations.header.name')}
              </BetmenListHeaderCell>
              <BetmenListHeaderCell>
                {t('doctor:patientProfile.vaccinations.header.date')}
              </BetmenListHeaderCell>
            </BetmenListHeader>
          }
        >
          <BetmenListBody>
            {patientDetails.vaccinations.map((vaccination) => (
              <BetmenListItemCard key={vaccination.id}>
                <BetmenListItemCardCell typographyProps={{ fontWeight: 700 }}>
                  {vaccination.code}
                </BetmenListItemCardCell>
                <BetmenListItemCardCell typographyProps={{ fontWeight: 700 }}>
                  {vaccination.name}
                </BetmenListItemCardCell>
                <BetmenListItemCardCell typographyProps={{ fontWeight: 400 }}>
                  {t('common:intlDateFormattedLongMonth', {
                    date: vaccination.date,
                  })}
                </BetmenListItemCardCell>

                <PatientDetailsActions isEditable={isEditable} />
              </BetmenListItemCard>
            ))}
          </BetmenListBody>
        </BetmenList>
      )}
    </Box>
  )
}
